import LectureLessonLecturerResourceListResultModel from '../../generated/types/model/resource/LectureLessonLecturerResourceListResultModel';

export default class LectureLessonLecturerResourceListResultViewModel extends LectureLessonLecturerResourceListResultModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
